function isSelected(type: string, id: string | number, store: any): boolean {
    return store.data.selected.autocompleteValue?.type === type && store.data.selected.autocompleteValue?.id === id
}

export default isSelected
